// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { ButtonRow, Button } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import message from '../messages';

interface SessionTimeoutWarningModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

const updateModalState = (state: { open: boolean }, closeModal: any) => {
    if (!state.open) {
        closeModal(false);
    }
};

const SessionTimeoutWarningModal: React.FC<SessionTimeoutWarningModalProps> = ({ isOpen, closeModal }) => {
    return (
        <Modal
            className="interruption-modal"
            title={message('sessionTimeoutWarningModalHeading')}
            isOpen={isOpen}
            appElement={document.getElementById('eService-agreement-root') ?? undefined}
            onUpdate={(state) => updateModalState(state, closeModal)}
            footer={
                <div className="modal-footer">
                    <ButtonRow>
                        <Button
                            primary
                            onClick={() => closeModal()}
                            data-testid="sessionTimeoutWarningModalCancelButton"
                        >
                            {message('yes')}
                        </Button>
                    </ButtonRow>
                </div>
            }
        >
            {message('sessionTimeoutWarningModalText')}
        </Modal>
    );
};

export default SessionTimeoutWarningModal;
